import { PageContent } from '@deere/fuel-react/PageContent.js';
import { useUserInfo } from '../../shared/UserInfo';
import NoAccessEmployee from '../NoAccessEmployee';
import MessageBanner from '../../shared/MessageBanner';
import { useStatusMessages } from '../../shared/StatusMessages';
import { useAPIProgress } from '../../shared/APIProgress';
import { Grid } from '@mui/material';
import { useState } from 'react';
import {
  ADMIN_FEATURES,
  STRATEGY_UPDATE,
  TEMPLATES
} from '../../shared/AppConstants';
import StrategyUpdates from './StrategyUpdate/StrategyUpdates';
import { StrategyTemplates } from './Templates/StrategyTemplates';
import { PageHeader } from '@deere/fuel-react/PageHeader.js';
import { PageHeaderTitle } from '@deere/fuel-react/PageHeaderTitle.js';
import { Typography } from '@mui/material';
import { Tabs } from '@mui/material';
import { Tab } from '@mui/material';

export default function AdminFeatures() {
  const info = useUserInfo();
  const isStrategyAdmin = info && info.isAdmin;
  const loggedInUser = info && info.userId;
  const {
    statusMessages,
    setStatusErrorMsg,
    setStatusInfoMsg,
    clearAllMessages,
    setStatusSuccessMsg
  } = useStatusMessages();
  const { apiInProgressCount, incrementAPIInProgress, decrementAPIInProgress } =
    useAPIProgress();

  const commonProps = {
    setStatusErrorMsg,
    incrementAPIInProgress,
    decrementAPIInProgress,
    setStatusInfoMsg,
    clearAllMessages,
    setStatusSuccessMsg
  };

  const [tab, setTab] = useState(0);

  const handleChange = (_event, newValue) => {
    setTab(newValue);
  };

  return !info ? (
    <></>
  ) : !isStrategyAdmin ? (
    <NoAccessEmployee userId={loggedInUser} />
  ) : (
    <>
      <PageHeader>
        <PageHeaderTitle>
          <Typography variant={'h1'}>{ADMIN_FEATURES}</Typography>
        </PageHeaderTitle>
        <Tabs onChange={handleChange} value={tab}>
          <Tab id={'strategy-update'} label={STRATEGY_UPDATE} />
          <Tab id={'templates'} label={TEMPLATES} />
        </Tabs>
      </PageHeader>

      <PageContent sx={{ minWidth: 0 }}>
        <Grid>
          <MessageBanner
            statusMessages={statusMessages}
            apiInProgressCount={apiInProgressCount}
          />
          {tab === 0 && <StrategyUpdates />}
          {tab === 1 && <StrategyTemplates commonProps={commonProps} />}
        </Grid>
      </PageContent>
    </>
  );
}
